// Shared formatting + calculation helpers for the analytics dashboards
// (support-admin and organizer). Keeping these here avoids the three
// separate copies that used to live in SupAnalytics.jsx, MostViewedTrips.jsx
// and SearchInsights.jsx.

// -----------------------------------------
// Date helpers
// -----------------------------------------

export const formatDate = (date) => {
    const year = date.getFullYear();

    const month = String(date.getMonth() + 1).padStart(2, '0');

    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export const getToday = () => {
    return formatDate(new Date());
};

export const getPresetDates = (preset) => {
    const today = new Date();

    let fromDate;
    const toDate = new Date(today);

    switch (preset) {
        case 'today':
            fromDate = new Date(today);
            break;

        case '7days':
            fromDate = new Date(today);

            fromDate.setDate(today.getDate() - 6);
            break;

        case '30days':
            fromDate = new Date(today);

            fromDate.setDate(today.getDate() - 29);
            break;

        case 'month':
            fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
            break;

        default:
            return null;
    }

    return {
        from: formatDate(fromDate),
        to: formatDate(toDate)
    };
};

// -----------------------------------------
// Number helpers
// -----------------------------------------

export const formatNumber = (value) => {
    return Number(value || 0).toLocaleString('en-IN');
};

// Funnel-style percentage: capped at 100, rounded to 1 decimal place.
// Used for stage-to-stage conversion rates (e.g. views -> bookings).
export const calculatePercentage = (value, base) => {
    const current = Number(value || 0);
    const total = Number(base || 0);

    if (!total || !current) {
        return 0;
    }

    return Math.min(100, Math.round((current / total) * 1000) / 10);
};

// Share-of-total percentage: whole number, not capped at 100.
// Used for "what share of searches went to this destination/type" bars,
// where the value is always a subset of the total so capping isn't needed.
export const calculateSharePercentage = (value, total) => {
    if (!total) {
        return 0;
    }

    return Math.round((Number(value || 0) / total) * 100);
};
